module.exports = __webpack_public_path__ + "static/media/facebook.100a1d06.png";